export const filterNames = {
  query: 'query',
  region: 'region',
  deliveryMethod: 'deliveryMethod',
  carrierService: 'carrierService',
}
